import { useEffect } from 'react';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { convertToDateObject, convertToISOString } from 'utils/helpers';

interface TimePickerTypes {
    value?: string | Date;
    name?: string;
    setValue?: (value: any) => void;
    disabled?: boolean;
    defaultNull?: boolean;
    label?: string;
}

export default function TimePickerValue({ value, setValue, disabled, defaultNull, label }: TimePickerTypes) {
    const formattedValue = defaultNull ? null : dayjs(value ? convertToDateObject(value) : null);
    const CLOCK_COLOR = '#0A7AFF';

    useEffect(() => {
        if (!value && !defaultNull) {
            const date = convertToISOString(new Date());
            setValue && setValue(date);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleTimeChange = (time: any) => {
        setValue && setValue(time);
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={['TimePicker', 'TimePicker']}>
                <TimePicker
                    slots={{
                        openPickerIcon: (props) => <AccessTimeIcon {...props} sx={{ color: CLOCK_COLOR }} />,
                    }}
                    label={label || 'Time'}
                    value={formattedValue}
                    onChange={handleTimeChange}
                    disabled={disabled}
                />
            </DemoContainer>
        </LocalizationProvider>
    );
}
